import { Image } from 'expo-image';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';

import { pencilIcon } from '@/assets/images/icons';

interface Props extends TouchableOpacityProps {
  size?: number;
}

const EditButton = (props: Props) => {
  const { size = 24 } = props;
  return (
    <TouchableOpacity {...props}>
      <Image source={pencilIcon} style={{ borderRadius: size / 2, height: size, width: size }} contentFit="contain" />
    </TouchableOpacity>
  );
};

export default EditButton;
